import { BreakpointObserver } from '@angular/cdk/layout';
import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';

import { CmsBlogHeaderComponentClass } from 'lib/components/cms/blog/cms-blog-header-component.class';

@Component({
    selector: 'app-cms-blog-header',
    templateUrl: './cms-blog-header.component.html',
    styleUrls: ['./cms-blog-header.component.scss'],
    standalone: false,
})
export class CmsBlogHeaderComponent extends CmsBlogHeaderComponentClass implements OnInit {
    constructor(@Inject(PLATFORM_ID) platformId: Object, breakpointObserver: BreakpointObserver) {
        super({ dependencies: { platformId, breakpointObserver } });
    }
}
